import clsx from "clsx";
import type { ThreadTimestampDisplay } from "./threadTimestampUtils";

export function ThreadTimestamp({
  display,
  className,
}: {
  display: ThreadTimestampDisplay;
  className?: string;
}) {
  const fade = "transition-opacity duration-200";

  if (display.visible) {
    return (
      <span
        className={clsx(
          "group relative inline-block cursor-default tabular-nums",
          className,
        )}
        aria-label={`${display.relative} (${display.absolute})`}
      >
        <span className={clsx(fade, "group-hover:opacity-0")}>
          {display.relative}
        </span>
        <span
          className={clsx(
            fade,
            "pointer-events-none absolute right-0 top-0 whitespace-nowrap opacity-0 group-hover:opacity-100",
          )}
          aria-hidden
        >
          {display.absolute}
        </span>
      </span>
    );
  }

  return (
    <span
      className={clsx(
        "group relative inline-flex min-h-[1em] min-w-[2rem] cursor-default items-center justify-end tabular-nums",
        className,
      )}
      aria-label={`${display.relative} (${display.absolute})`}
    >
      <span
        className={clsx(
          fade,
          "absolute right-0 whitespace-nowrap opacity-0 group-hover:opacity-100",
        )}
      >
        {display.absolute}
      </span>
    </span>
  );
}
